export function bookmark(){
  if(document.querySelector(".js-bookmark")){

    const bookmarkButtons = document.querySelectorAll('.js-bookmark');

    bookmarkButtons.forEach(button => {
      button.addEventListener('click', () => {
        button.classList.toggle("active")
        button.setAttribute(
            'aria-pressed',
            (button.getAttribute('aria-pressed') !== 'true').toString()
            );
      })
    })
  }
}

export default bookmark;